/**
 * Utilidades para orientar flechas de trazabilidad GPS en mapas.
 * Si no hay heading del satelital, se calcula el rumbo hacia el punto siguiente.
 */

export function parseCoordGps(value) {
  if (value == null || value === "") return null;
  const n = parseFloat(String(value).replace(",", "."));
  return Number.isFinite(n) ? n : null;
}

export function parseHeadingGps(value) {
  if (value == null || value === "") return null;
  const n = parseFloat(String(value).replace(",", "."));
  return Number.isFinite(n) ? n : null;
}

export function calcularBearingGrados(lat1, lon1, lat2, lon2) {
  const lat1Rad = (lat1 * Math.PI) / 180;
  const lat2Rad = (lat2 * Math.PI) / 180;
  const deltaLonRad = ((lon2 - lon1) * Math.PI) / 180;

  const y = Math.sin(deltaLonRad) * Math.cos(lat2Rad);
  const x =
    Math.cos(lat1Rad) * Math.sin(lat2Rad) -
    Math.sin(lat1Rad) * Math.cos(lat2Rad) * Math.cos(deltaLonRad);

  let bearingDeg = (Math.atan2(y, x) * 180) / Math.PI;
  bearingDeg = (bearingDeg + 360) % 360;

  return Math.round(bearingDeg);
}

/**
 * Rotación para SVG de flecha (0° = norte del ícono apunta arriba en el asset).
 * @param {Array} puntos
 * @param {number} index
 * @param {{ headingKey?: string, latKey?: string, lngKey?: string }} [options]
 * @returns {number}
 */
export function getRotacionFlechaTraza(puntos, index, options = {}) {
  const headingKey = options.headingKey || "intHeading";
  const latKey = options.latKey || "latitud";
  const lngKey = options.lngKey || "longitud";

  const punto = puntos[index];
  if (!punto) return -180;

  const heading = parseHeadingGps(
    punto[headingKey] != null ? punto[headingKey] : punto.direccion
  );
  if (heading != null) {
    return heading - 180;
  }

  const lat1 = parseCoordGps(punto[latKey]);
  const lng1 = parseCoordGps(punto[lngKey]);

  const siguiente = puntos[index + 1];
  if (siguiente) {
    const lat2 = parseCoordGps(siguiente[latKey]);
    const lng2 = parseCoordGps(siguiente[lngKey]);
    if (lat1 != null && lng1 != null && lat2 != null && lng2 != null) {
      return calcularBearingGrados(lat1, lng1, lat2, lng2) - 180;
    }
  }

  const anterior = puntos[index - 1];
  if (anterior) {
    const lat0 = parseCoordGps(anterior[latKey]);
    const lng0 = parseCoordGps(anterior[lngKey]);
    if (lat0 != null && lng0 != null && lat1 != null && lng1 != null) {
      return calcularBearingGrados(lat0, lng0, lat1, lng1) - 180;
    }
  }

  return -180;
}
